import React, { useState } from "react";
import { useNavigate, useLocation } from "react-router-dom";
import { motion } from "framer-motion";
import { useAuth } from "../context/AuthContext";
import { FaLock } from "react-icons/fa";
import { BASE_ENDPOINT } from "../helpers/Config";
import axios from "axios";
import toast from "react-hot-toast";

export default function Login() {
    const { login } = useAuth();
    const navigate = useNavigate();
    const location = useLocation();

    const [username, setUsername] = useState("");
    const [password, setPassword] = useState("");
    const [loading, setLoading] = useState(false);

    const onSubmit = async (e) => {
        e.preventDefault();
        setLoading(true);
        try {
            const response = await axios({
                method: "post",
                url: `${BASE_ENDPOINT}/auth/admin-login`,
                maxBodyLength: Infinity,
                headers: {
                    "Content-Type": "application/json"
                },
                data: {
                    username,
                    password
                }
            });

            const data = response?.data;

            if (data?.error) {
                toast.error(data?.error)
            } else {
                const token = data?.token;
                const msg = data?.msg;

                toast.success(msg);

                await login({ token });
                navigate('/', { replace: true });
            }


        } catch (error) {
            console.log(error);
            toast.error('Try again later')

        } finally {
            setLoading(false);
        }
    };

    return (
        <div className="container-fluid min-vh-100 d-flex align-items-center justify-content-center bg-light p-3">
            <motion.div
                initial={{ opacity: 0, y: 14 }}
                animate={{ opacity: 1, y: 0 }}
                transition={{ duration: 0.25 }}
                className="w-100"
                style={{ maxWidth: 420 }}
            >
                <div className="card shadow-sm border-0">
                    <div className="card-body p-4 p-md-5">
                        <div className="d-flex align-items-center gap-2 mb-2">
                            <div className="bg-primary text-white rounded-circle d-inline-flex align-items-center justify-content-center"
                                style={{ width: 36, height: 36 }}>
                                <FaLock />
                            </div>
                            <div>
                                <h1 className="h5 mb-0 fw-bold">Sign in</h1>
                                <div className="text-muted small">Access your admin panel</div>
                            </div>
                        </div>

                        <form className="mt-4" onSubmit={onSubmit}>
                            <div className="mb-3">
                                <label className="form-label small fw-semibold">Email</label>
                                <input
                                    className="form-control"
                                    type="text"
                                    value={username}
                                    onChange={(e) => setUsername(e.target.value)}
                                    placeholder="Enter username"
                                    required
                                />
                            </div>

                            <div className="mb-3">
                                <label className="form-label small fw-semibold">Password</label>
                                <input
                                    className="form-control"
                                    type="password"
                                    value={password}
                                    onChange={(e) => setPassword(e.target.value)}
                                    placeholder="Enter password"
                                    required
                                />
                            </div>

                            <button
                                className="btn btn-primary w-100 fw-semibold"
                                disabled={loading}
                            >
                                {loading ? "Signing in..." : "Sign in"}
                            </button>
                        </form>
                    </div>
                </div>
            </motion.div>
        </div>
    );
}
